import { Logger, LoggerService } from "@Shared/logger";
import { PipelineContext, PipelineStep } from "@Modules/pipeline_module/_base";
import {SessionService} from "@Modules/session_module";
import { buildPostCallbackStep } from "../auth/check-auth-status.step";


export class MaybeUpdateSessionServerStep implements PipelineStep {
    private sessionService: SessionService;
    private Logger: Logger = LoggerService.createLogger("UpdateSessionStep");
    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace("Executing....");
        this.sessionService = SessionService.Instance;

        if(context.sessionServerNeedsUpdate){
            await this.sessionService.maybeUpdateWholeSession(context.checkEntitlements.mngSession);
        }
        // buildPostCallbackStep for /callback round-trip (Apple News sub-check + generic auth_redirect)
        // No-op when not on /callback, so safe to chain unconditionally.
        return buildPostCallbackStep();
    }
}